import { render } from "./NotificationMarker.vue?vue&type=template&id=97b248aa"
import script from "./NotificationMarker.vue?vue&type=script&lang=js"
export * from "./NotificationMarker.vue?vue&type=script&lang=js"

import "./NotificationMarker.vue?vue&type=style&index=0&id=97b248aa&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__